import {
    Row,
    Col,
    Card,
    Radio,
    Table,
    Upload,
    message,
    Progress,
    Button,
    Avatar,
    Typography,
    Space,
    Popconfirm,
    Select,
    Input,
    Tooltip,
    Divider, notification, Tag

} from "antd";

import {useState} from "react";
import moment from "moment/moment";
import {
    CheckCircleOutlined,
    CloseCircleOutlined, DownCircleFilled,
    DownloadOutlined,
    ExportOutlined,
    FileDoneOutlined,
    FileProtectOutlined, FileWordOutlined, FilePdfOutlined, MailOutlined, PrinterOutlined,
    MergeCellsOutlined,
    PlusOutlined,
    RightOutlined,
    RollbackOutlined,
    SafetyCertificateOutlined,
    SaveOutlined,
    UserDeleteOutlined,
    UserSwitchOutlined
} from "@ant-design/icons";
import CreateRequestStackDialog from "../dialogs/CreateRequestStackDialog";
import ReassignStackDialog from "../dialogs/ReassignStackDialog";
import {closeStack, submitStack, reopenStack, closeAndCreateReviewStack, rollbackReviewStack} from "../../store/app/app.slice";
import {
    getLanguagesLabel, getStackStatusLabel, getStackTypeLabel,
    letterStatusFilterDropdown,
    stackStatusFilterDropdown,
    stackTypeFilterDropdown
} from "../helper/labelHelper";
import {getAuthenticatedUser} from "../../utils/authHelper";
import {StackDto} from "ps-letter-mgmtrest-client";
import {useDispatch} from "react-redux";


const {Option} = Select;
const {Title} = Typography;


export function getCategoryColor(category) {
    // Define color mapping for categories
    const colorMap = {
        Health: "#ffd700",
        Study: "#4169e1",
        Rishta: "#ff6347",
        Jamaat: "#ff0000",
        Parents: "#32cd32",
        Jamia: "#ffa500",
        Children: "#1e90ff",
        Economy: "#8a2be2",
        Testcategory: "#e5005e",
    };
    return colorMap[category] || "#000000";
}

export function getStatusColor(status) {
    // Define color mapping for statuses
    const colorMap = {
        REQUESTED: "#6f7173",
        ASSIGNED: "#52c41a",
        DELIVERED: "#4255ff",
        SUBMITTED: "#884712",
        CLOSED: "#000000",
    };
    return colorMap[status] || "#000000";
}

export function getStackTypeColor(stackType) {
    // Define color mapping for statuses
    const colorMap = {
        FILTRATION: "#5c5959",
        SUMMARY: "#5c5959",
        ANSWER: "#5c5959",
    };
    return colorMap[stackType] || "#000000";
}

function StackRequestsTable({
                                stackRequests,
                                handleRemoveRequest,
                                handleConfirmRequest,
                                showNewStackRequestModal,
                                showNewStackRequestTitle,
                                stackType,
                                title,
                                showReferencedStack,
                                navigateToStackDetailsView
                            }) {
    const [editingAmounts, setEditingAmounts] = useState({});
    const [assignmentTypes, setAssignmentTypes] = useState({});

    const columns = [];

    if (showReferencedStack) {
        columns.push({
            title: "Summary Stack",
            dataIndex: ["linkedStack", "id"],
            key: "linkedStackId",
            render: (linkedStackId, record) => {
                return (
            <a
              class="hover-link"
              onClick={() => navigateToStackDetailsView(record?.linkedStack)}
            >
                        {linkedStackId}
                    </a>
                );
            }
        },
        {
            title: "Summarized by",
            dataIndex: ["linkedStack", "assigneeName"],
            key: "linkedStackAssigneeName",
        render: (summarizedBy, record) => {
          return (
            <span
              class="hover-link"
              onClick={() => navigateToStackDetailsView(record)}
            >
              {summarizedBy}
            </span>
          );
        },
      }
    );
    }

    columns.push(
        {
            title: "Requester Name",
            dataIndex: "requesterName",
            key: "requesterName",

        },
        {
            title: "New Stack ID",
            dataIndex: "id",
            key: "id",
        },
        {
            title: "Amount",
            dataIndex: "requestedAmount",
            key: "requestedAmount",
        },
        {
            title: "Language",
            dataIndex: "requestedLanguages",
            key: "requestedLanguages",
            render: (requestedLanguages) => {
                if (!requestedLanguages || !Array.isArray(requestedLanguages)) {
                    return <span>-</span>;
                }

                const nonNullLanguages = requestedLanguages.filter(lang => lang != null);

                if (nonNullLanguages.length === 0) {
                    return <span>-</span>;
                }

                return <span>{nonNullLanguages.map(lng => getLanguagesLabel(lng)).join('/')}</span>;
            },
        });

    if (getAuthenticatedUser().isPortalSupervisor()) {
        
        columns.push(
            {
                title: "Accept / Remove Request",
                key: "removeAssignment",
                render: (_, record) => (
                    <Space split={<Divider type="vertical"/>}>
                        <Tooltip title="Confirm Request">
                            <Popconfirm
                                title="Are you sure you want to confirm this request?"
              onConfirm={(e) => {
                e.stopPropagation();
                handleConfirmRequest({
                                    ...record,
                  editedAmount:
                    editingAmounts[record.id] || record.requestedAmount,
                  assignmentType: assignmentTypes[record.id] || "AUTO_ASSIGN",
                });
              }}
              onCancel={(e) => e.stopPropagation()}
                                okText="Yes"
                                cancelText="No"
                            >
              <CheckCircleOutlined
                onClick={(e) => e.stopPropagation()}
                style={{ color: "green", cursor: "pointer", fontSize: "22px" }}
              />
                            </Popconfirm>
                        </Tooltip>
                        <Tooltip title="Remove Request">
                            <Popconfirm
                                title="Are you sure you want to remove this request?"
              onConfirm={(e) => {
                e.stopPropagation();
                handleRemoveRequest(record);
              }}
              onCancel={(e) => e.stopPropagation()}
                                okText="Yes"
                                cancelText="No"
                            >
              <CloseCircleOutlined
                onClick={(e) => e.stopPropagation()}
                style={{ color: "red", cursor: "pointer", fontSize: "22px" }}
              />
                            </Popconfirm>
                        </Tooltip>
                    </Space>
                ),
            })
        
        
    } else {
        columns.push(
            {
                title: "Next Step",
                key: "stackAction",
                render: (_, record) => (
                    <Button className={"ant-tag-orange"} type="default">
                        Waiting for Supervisor
                    </Button>
                ),
            },
            {
                title: "Cancel Request",
                key: "cancelAssignment",
                render: (_, record) => (
                    <Space>
                        <Tooltip title="Remove Request">
                            <Popconfirm
                                title="Are you sure you want to cancel this request?"
                onConfirm={(e) => {
                  e.stopPropagation();
                  handleRemoveRequest(record);
                }}
                onCancel={(e) => e.stopPropagation()}
                                okText="Yes"
                                cancelText="No"
                            >
                <CloseCircleOutlined
                  onClick={(e) => e.stopPropagation()}
                  style={{ color: "red", cursor: "pointer", fontSize: "22px" }}
                />
                            </Popconfirm>
                        </Tooltip>
                    </Space>
                ),
            })
    }

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={title}
            extra={showNewStackRequestModal ?
                <Button type="primary" onClick={showNewStackRequestModal}><PlusOutlined/>{showNewStackRequestTitle}
                </Button> : ""}
        >
            <div className="table-responsive">
                <Table
                    columns={columns}
                    dataSource={stackRequests}
                    pagination={true}
                    className="ant-border-space"
                    onRow={(record, rowIndex) => {
                        return {
              onClick: (event) => {
                navigateToStackDetailsView(record?.linkedStack);
                            }, // click row
              onDoubleClick: (event) => {}, // double click row
              onContextMenu: (event) => {}, // right button click row
              onMouseEnter: (event) => {}, // mouse enter row
              onMouseLeave: (event) => {}, // mouse leave row
                        };
                    }}
                />
            </div>
        </Card>
    );
}

function AssignedStacksTable({
                                 assignedStacks,
                                 navigateToStackDetailsView,
                                 handleUnassignRequest,
                                 fetchData,
                                 showNewStackRequestModal,
                                 showNewStackRequestTitle,
                                 stackType,
                                 title,
                                 showReferencedStack,
                                 handleJoinStacks
                             }) {
    const [openReassignStackDialog, setOpenReassignStackDialog] = useState(false);
    const [currentStackId, setCurrentStackId] = useState(null);
    const [selectedStackIds, setSelectedStackIds] = useState([]);
    const [rollingBackReviewStack, setRollingBackReviewStack] = useState(false);
    const dispatch = useDispatch();

    const handleJoinClick = () => {
        const selectedStacks = assignedStacks.filter(stack => selectedStackIds.includes(stack.id));
        const firstStack = selectedStacks[0];

        if (!selectedStacks.every(stack => stack.assigneeId === firstStack.assigneeId)) {
            message.error({content: "Only stacks with the same worker can be joined"});
            return;
        }
        if (!selectedStacks.every(stack => JSON.stringify(stack.assignedLanguages) === JSON.stringify(firstStack.assignedLanguages))) {
            message.error({content: "Only stacks with the same language can be joined"});
            return;
        }
        handleJoinStacks(selectedStackIds, () => setSelectedStackIds([]));
    };

    const handleRollbackReviewStack = (record) => {
        setRollingBackReviewStack(true);
        dispatch(rollbackReviewStack({
            finalData: {stackId: record.id},
            callbackSuccess: (response) => {
                setRollingBackReviewStack(false);
                notification['success']({
                    message: 'Review Stack rolled back',
                    description: 'Review Stack #' + record.id + ' was deleted. Answer Stack #' + response.id + ' is back in Printed Answers.',
                });
                fetchData();
            },
            callbackError: (error) => {
                setRollingBackReviewStack(false);
                notification['error']({
                    message: 'Error rolling back review stack',
                    description: error,
                });
            }
        }));
    };

    const showModal = (stackId) => {
        setCurrentStackId(stackId);
        setOpenReassignStackDialog(true);
    };

    const hideModal = () => {
        setCurrentStackId(null);
        setOpenReassignStackDialog(false);
    }

    const columns = [];

    if (showReferencedStack) {
        if (stackType === "REVIEW_ANSWER") {
            columns.push({
                title: "Summary Stack",
                dataIndex: ["linkedStack", "linkedStack", "id"],
                key: "summaryStackId",
                render: (summaryStackId, record) => {
                    return (
                        <a onClick={() => navigateToStackDetailsView(record?.linkedStack?.linkedStack)}>
                            {summaryStackId}
                        </a>
                    );
                }
            });
        }
        columns.push({
            title: stackType === "REVIEW_ANSWER" ? "Answer Stack" : "Summary Stack",
            dataIndex: ["linkedStack", "id"],
            key: "linkedStackId",
            render: (linkedStackId, record) => {
                return (
                    <a onClick={() => navigateToStackDetailsView(record)}>
                        {linkedStackId}
                    </a>
                );
            }
        });
    }

    columns.push(
        {
            title: "Stack ID",
            dataIndex: "id",
            key: "id",
            render: (id, record) => {
                return (
          <a
            class="hover-link"
            onClick={() => navigateToStackDetailsView(record)}
          >
                        {record.id}
                    </a>
                );
            }
        },
        {
            title: "Worker Name",
            dataIndex: "assigneeName",
            key: "assigneeName",
      render: (name, record) => (
        <span
          className="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {name}
        </span>
      ),
        },
        {
            title: "Assigned Amount",
            dataIndex: "assignedAmount",
            key: "assignedAmount",
      render: (amount, record) => (
        <span
          className="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {amount}
        </span>
      ),
        },
        {
            title: "Assigned Languages",
            dataIndex: "assignedLanguages",
            key: "assignedLanguages",
            render: (assignedLanguages) => {
                if (!assignedLanguages || !Array.isArray(assignedLanguages)) {
                    return <span>-</span>;
                }

                const nonNullLanguages = assignedLanguages.filter(lang => lang != null);

                if (nonNullLanguages.length === 0) {
                    return <span>-</span>;
                }

        return (
          <span className="hover-link">
            {nonNullLanguages.map((lng) => getLanguagesLabel(lng)).join("/")}
          </span>
        );
            },
        },
        {
            title: "Last Update",
            dataIndex: "modified",
            key: "modified",
            render: (date) => (date ? moment(date).format("DD-MM-YYYY / hh:mm A") : "N/A"),
        }
    );

    if (getAuthenticatedUser().isPortalSupervisor() && stackType !== "REVIEW_ANSWER") {
        columns.push(
            {
                title: "Reassign / Unassign",
                key: "reAndUnAssignment",
                render: (_, record) => (
        <Space split={<Divider type="vertical" />}>
          <UserSwitchOutlined
            style={{ color: "green", cursor: "pointer", fontSize: "22px" }}
            onClick={(e) => {
              e.stopPropagation();
              showModal(record.id);
            }}
          />
                        <Tooltip title="Unassign Stacke">
                            <Popconfirm
                                title="Are you sure you want to unassing this Stack? All linked letters will be unassigned."
              onConfirm={(e) => {
                e.stopPropagation();
                handleUnassignRequest(record);
              }}
              onCancel={(e) => e.stopPropagation()}
                                okText="Yes"
                                cancelText="No"
                            >
              <UserDeleteOutlined
                onClick={(e) => e.stopPropagation()}
                style={{ color: "red", cursor: "pointer", fontSize: "22px" }}
              />
                            </Popconfirm>
                        </Tooltip>
                    </Space>
                ),
            }
        )
    } else {
        columns.push(
            {
                title: "Action",
                key: "stackAction",
                render: (_, record: StackDto) => (
                    <Space>
                        <Button className={"ant-tag-orange"} type="default" onClick={() => {
                            navigateToStackDetailsView(record)
                        }}>
                            {record.assignedStackType === "FILTRATION" ? "Do Filtration" : record.assignedStackType === "SUMMARY" ? "Do Summary" : record.assignedStackType === "REVIEW_ANSWER" ? "Review Email PDFs" : "Write Answers"}
                        </Button>
                        {record.assignedStackType === "REVIEW_ANSWER" ? (
                            <Popconfirm
                                title={"Roll back Review Stack #" + record.id + "? It will be deleted and Answer Stack #" + (record.linkedStack ? record.linkedStack.id : "?") + " returns to Printed Answers."}
                                onConfirm={(e) => {
                                    e.stopPropagation();
                                    handleRollbackReviewStack(record);
                                }}
                                onCancel={(e) => e.stopPropagation()}
                                okText="Yes, roll back"
                                cancelText="No"
                            >
                                <Button
                                    className={"ant-tag-red"}
                                    type="default"
                                    danger
                                    loading={rollingBackReviewStack}
                                    disabled={rollingBackReviewStack}
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <RollbackOutlined /> Rollback Stack
                                </Button>
                            </Popconfirm>
                        ) : ""}
                    </Space>
                ),
            }
        )
    }

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={title}
            extra={<Space>
                {handleJoinStacks ?
                    <Popconfirm
                        title={"Join " + selectedStackIds.length + " stacks into Stack #" + Math.min(...selectedStackIds) + "? The other stacks will be removed."}
                        onConfirm={handleJoinClick}
                        okText="Yes"
                        cancelText="No"
                        disabled={selectedStackIds.length < 2}
                    >
                        <Button type="primary" disabled={selectedStackIds.length < 2}><MergeCellsOutlined/> Join Stacks</Button>
                    </Popconfirm> : ""}
                {showNewStackRequestModal ?
                    <Button type="primary" onClick={showNewStackRequestModal}><PlusOutlined/>{showNewStackRequestTitle}
                    </Button> : ""}
            </Space>}
        >
            <div className="table-responsive">
                <Table
                    columns={columns}
                    dataSource={assignedStacks}
                    rowKey="id"
                    rowSelection={handleJoinStacks ? {
                        selectedRowKeys: selectedStackIds,
                        onChange: (selectedKeys) => setSelectedStackIds(selectedKeys),
                        renderCell: (checked, record, index, originNode) => (
                            <span onClick={(e) => e.stopPropagation()}>{originNode}</span>
                        ),
                    } : undefined}
                    pagination={true}
                    className="ant-border-space"
                    onRow={(record, rowIndex) => {
                        return {
              onClick: (event) => {
                navigateToStackDetailsView(record);
                            }, // click row
              onDoubleClick: (event) => {}, // double click row
              onContextMenu: (event) => {}, // right button click row
              onMouseEnter: (event) => {}, // mouse enter row
              onMouseLeave: (event) => {}, // mouse leave row
                        };
                    }}
                />
            </div>
            <ReassignStackDialog showModal={openReassignStackDialog} onHideModal={hideModal} stackId={currentStackId}
                                 fetchData={fetchData}/>
        </Card>
    );
}

function DeliveredStacksTable({
                                  assignedStacks,
                                  navigateToStackDetailsView,
                                  handleSubmitStack,
                                  handleCloseStack,
                                  handleDownloadStackAttachment,
                                  handleDownloadStackPdfs,
                                  pdfGenerating,
                                  fetchData,
                                  title,
                                  showNewStackRequestModal,
                                  showNewStackRequestTitle,
                                  stackType,
                                  handleLinkedStackRequest,
                                  areNotAnsweredStacks,
                                  showReferencedStack
                              }) {
    const [openReassignStackDialog, setOpenReassignStackDialog] = useState(false);
    const [currentStackId, setCurrentStackId] = useState(null);
    const [creatingReviewStack, setCreatingReviewStack] = useState(false);
    const dispatch = useDispatch();

    const handleReopenStack = (record) => {
        dispatch(reopenStack({
            finalData: {stackId: record.id},
            callbackSuccess: () => {
                message.success("Stack reopened successfully");
                fetchData();
            },
            callbackError: (error) => {
                message.error(error);
            }
        }));
    };

    const handleCreateReviewStack = (record) => {
        setCreatingReviewStack(true);
        dispatch(closeAndCreateReviewStack({
            finalData: {stackId: record.id},
            callbackSuccess: (response) => {
                setCreatingReviewStack(false);
                notification['success']({
                    message: 'Answer Delivery Stack created',
                    description: 'Review Stack #' + response.id + ' has been created and assigned.',
                });
                fetchData();
            },
            callbackError: (error) => {
                setCreatingReviewStack(false);
                notification['error']({
                    message: 'Error creating review stack',
                    description: error,
                });
            }
        }));
    };

    const showModal = (stackId) => {
        setCurrentStackId(stackId);
        setOpenReassignStackDialog(true);
    };

    const hideModal = () => {
        setCurrentStackId(null);
        setOpenReassignStackDialog(false);
    }

    const columns = [];
    if (showReferencedStack) {
        if (stackType === "REVIEW_ANSWER") {
            columns.push({
                title: "Summary Stack",
                dataIndex: ["linkedStack", "linkedStack", "id"],
                key: "summaryStackId",
                render: (summaryStackId, record) => {
                    return (
                        <a onClick={() => navigateToStackDetailsView(record?.linkedStack?.linkedStack)}>
                            {summaryStackId}
                        </a>
                    );
                }
            });
        }
        columns.push({
            title: stackType === "REVIEW_ANSWER" ? "Answer Stack" : "Summary Stack",
            dataIndex: ["linkedStack", "id"],
            key: "linkedStackId",
            render: (linkedStackId, record) => {
                return (
          <a
            className="hover-link"
            onClick={() => navigateToStackDetailsView(record)}
          >
                        {linkedStackId}
                    </a>
                );
            }
        });
    }
    columns.push(
        {
            title: "Stack ID",
            dataIndex: "id",
            key: "id",
            render: (id, record) => {
                return (
          <a
            className="hover-link"
            onClick={() => navigateToStackDetailsView(record)}
          >
                        {record.id}
                    </a>
                );
            }
        },
        {
            title: "Worker Name",
            dataIndex: "assigneeName",
            key: "assigneeName",
      render: (name, record) => (
        <span
          className="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {name}
        </span>
      ),
        },
        {
            title: "Assigned Amount",
            dataIndex: "assignedAmount",
            key: "assignedAmount",
      render: (amount, record) => (
        <span
          className="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {amount}
        </span>
      ),
        },
        {
            title: "Delivery",
            key: "deliveryTotals",
            render: (_, record) => {
                if (record.assignedStackType !== "REVIEW_ANSWER"
                    || record.downloadedCount === undefined
                    || record.downloadedCount === null) {
                    return <span>-</span>;
                }
                return (
                    <Space size={4} wrap>
                        <Tooltip title="Answer PDFs downloaded">
                            <Tag color="green">{record.downloadedCount} downloaded</Tag>
                        </Tooltip>
                        <Tooltip title="Answers delivered by e-mail">
                            <Tag color="blue">{record.deliveredCount} delivered</Tag>
                        </Tooltip>
                        <Tooltip title="Letters going out by post">
                            <Tag>{record.postCount} posted</Tag>
                        </Tooltip>
                        <Tooltip title="E-mail delivery failed — these need attention">
                            <Tag color="red">{record.deliveryFailedCount || 0} failed</Tag>
                        </Tooltip>
                    </Space>
                );
            },
        },
        {
            title: "Assigned Languages",
            dataIndex: "assignedLanguages",
            key: "assignedLanguages",
            render: (assignedLanguages) => {
                if (!assignedLanguages || !Array.isArray(assignedLanguages)) {
                    return <span>-</span>;
                }

                const nonNullLanguages = assignedLanguages.filter(lang => lang != null);

                if (nonNullLanguages.length === 0) {
                    return <span>-</span>;
                }

                return <span>{nonNullLanguages.map(lng => getLanguagesLabel(lng)).join('/')}</span>;
            },
        },
        {
            title: "Last Update",
            dataIndex: "modified",
            key: "modified",
            render: (date) => (date ? moment(date).format("DD-MM-YYYY / hh:mm A") : "N/A"),
        }
    );

    switch (stackType) {
        case "FILTRATION":
            break;
        case "SUMMARY":
            columns.push(
                {
                    title: <><DownloadOutlined/> Attachments</>,
                    key: "stackAction",
                    render: (_, record) => (
          <Button
            className={"ant-tag-green"}
            type="default"
            onClick={(e) => {
              e.stopPropagation();
              handleDownloadStackAttachment(record);
            }}
          >
            <FileWordOutlined />
            Summary
                        </Button>
                    ),
                }
            )
            columns.push({
        title: "Next Step",
        key: "stackAction",
        render: (_, record) =>
          record.status === "CLOSED" && !areNotAnsweredStacks ? (
            <Button
              type="text"
              style={{
                backgroundColor: getStatusColor(record.status),
                color: "white",
              }}
            >
              {getStackStatusLabel(record.status)}
            </Button>
          ) : record.status === "SUBMITTED" ?
          (
            <Space>
              <Button
                className={"ant-tag-blue"}
                type="default"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseStack(record);
                }}
              >
                <SafetyCertificateOutlined /> Summary viewed by Huzoor
                <sup>aa</sup>
              </Button>

              <Button
                className={"ant-tag-orange"}
                type="default"
                onClick={(e) => {
                  e.stopPropagation();
                  handleReopenStack(record);
                }}
              >
                <RightOutlined /> Reopen Stack
              </Button>
            </Space>
          ) : record.status === "CLOSED" ? (
            <Button
              className={"ant-tag-blue"}
              type="default"
              onClick={(e) => {
                e.stopPropagation();
                handleLinkedStackRequest(record);
              }}
            >
              <SafetyCertificateOutlined /> Create Answering Stack
            </Button>
          ) : (
            ""
          ),
      });
            break;
        case "ANSWER":
      columns.push({
        title: (
          <>
            <DownloadOutlined /> Attachments
          </>
        ),
                    key: "stackAction",
                    render: (_, record) => (
          <Space>
            <Button
              className={"ant-tag-green"}
              type="default"
              disabled={pdfGenerating}
              onClick={(e) => {
                e.stopPropagation();
                handleDownloadStackAttachment(record);
              }}
            >
              <FileWordOutlined />
              Answers
            </Button>
          </Space>
                    ),
      });
      columns.push({
                    title: "Next Step",
                    key: "stackAction",
        render: (_, record) =>
          record.status === "CLOSED" ? (
            <Button
              type="text"
              style={{
                backgroundColor: getStatusColor(record.status),
                color: "white",
              }}
            >
                            {getStackStatusLabel(record.status)}
            </Button>
          ) : (
                        <Space>
              <Button
                className={"ant-tag-red"}
                type="default"
                danger
                loading={creatingReviewStack}
                disabled={creatingReviewStack}
                onClick={(e) => {
                  e.stopPropagation();
                  handleCreateReviewStack(record);
                }}
              >
                                <FileProtectOutlined /> Review Email PDFs
                            </Button>
              <Button
                className={"ant-tag-blue"}
                type="default"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseStack(record);
                }}
              >
                                <SafetyCertificateOutlined /> Archive Stack
                            </Button>
              <Button
                className={"ant-tag-orange"}
                type="default"
                onClick={(e) => {
                  e.stopPropagation();
                  handleReopenStack(record);
                }}
              >
                                <RightOutlined /> Reopen Stack
                            </Button>
                        </Space>
                    ),
                }
            )
            break;
        case "REVIEW_ANSWER":
      columns.push({
        title: (
          <>
            <DownloadOutlined /> Attachments
          </>
        ),
                    key: "stackAction",
                    render: (_, record) => (
          <Space>
              <Button
                className={"ant-tag-blue"}
                type="default"
                loading={pdfGenerating}
                disabled={pdfGenerating}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadStackAttachment(record);
                }}
              >
                <FilePdfOutlined />
                All PDFs
              </Button>
              <Button
                className={"ant-tag-green"}
                type="default"
                loading={pdfGenerating}
                disabled={pdfGenerating}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadStackAttachment(record, "EMAIL");
                }}
              >
                <MailOutlined />
                Email PDFs
              </Button>
              <Button
                className={"ant-tag-orange"}
                type="default"
                loading={pdfGenerating}
                disabled={pdfGenerating}
                onClick={(e) => {
                  e.stopPropagation();
                  handleDownloadStackAttachment(record, "POST");
                }}
              >
                <PrinterOutlined />
                Post PDFs
              </Button>
          </Space>
                    ),
      });
      columns.push({
                    title: "Next Step",
                    key: "stackAction",
        render: (_, record) =>
          record.status === "CLOSED" ? (
            <Button
              type="text"
              style={{
                backgroundColor: getStatusColor(record.status),
                color: "white",
              }}
            >
                            {getStackStatusLabel(record.status)}
            </Button>
          ) : (
                        <Space>
              <Button
                className={"ant-tag-blue"}
                type="default"
                onClick={(e) => {
                  e.stopPropagation();
                  handleCloseStack(record);
                }}
              >
                                <SafetyCertificateOutlined /> Close Stack
                            </Button>
                        </Space>
                    ),
                }
            )
            break;
        default:

            break;
    }

    if (getAuthenticatedUser().isPortalSupervisor()) {
        switch (stackType) {
            case "FILTRATION":
                columns.push(
                    {
                        title: "Review",
                        key: "reviewFiltrationAction",
                        render: (_, record) => (
                            <Space direction={"horizontal"} align={"center"}>
                                <FileDoneOutlined style={{color: 'orange', cursor: 'pointer', fontSize: '22px'}}
                                                  onClick={() => navigateToStackDetailsView(record)}/>
                            </Space>
                        ),
        });
        columns.push({
                        title: "Approve",
                        key: "approveFiltrationAction",
          render: (_, record) =>
            record.status === "CLOSED" ? (
              <Button
                type="text"
                style={{
                  backgroundColor: getStatusColor(record.status),
                  color: "white",
                }}
              >
                            {getStackStatusLabel(record.status)}
              </Button>
            ) : (
                            <Space direction={"horizontal"} align={"center"}>
                <SafetyCertificateOutlined
                  style={{
                    color: "green",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseStack(record);
                  }}
                />
                            </Space>
                        ),
        });
                break;
            case "SUMMARY":
                break;
            case "ANSWER":
                break;
            case "REVIEW_ANSWER":
                break;
            default:
        columns.push({
                        title: "Submit | Download | Close",
                        key: "actions",
                        render: (_, record) => (
            <Space split={<Divider type="vertical" />}>
              {record.status === "DELIVERED" &&
              (record.assignedStackType === "SUMMARY" ||
                record.assignedStackType === "ANSWER") ? (
                <SaveOutlined
                  style={{
                    color: "green",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleSubmitStack(record);
                  }}
                />
              ) : (
                <SaveOutlined
                  style={{
                    color: "lightgray",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                />
              )}
              {record.status === "SUBMITTED" &&
              (record.assignedStackType === "SUMMARY" ||
                record.assignedStackType === "ANSWER") ? (
                                    <DownloadOutlined
                  style={{
                    color: "green",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDownloadStackAttachment(record);
                  }}
                />
              ) : (
                <DownloadOutlined
                  style={{
                    color: "lightgray",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                />
              )}
              {(record.status === "DELIVERED" &&
                record.assignedStackType === "FILTRATION") ||
              record.status === "SUBMITTED" ? (
                                    <CheckCircleOutlined
                  style={{
                    color: "green",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCloseStack(record);
                  }}
                />
              ) : (
                <CheckCircleOutlined
                  style={{
                    color: "lightgray",
                    cursor: "pointer",
                    fontSize: "22px",
                  }}
                />
              )}
                            </Space>
                        ),
        });
                break;
        }
    } else {
        switch (stackType) {
            case "FILTRATION":
                columns.push(
                    {
                        title: "Next Step",
                        key: "stackAction",
                        render: (_, record) => (
                            record.status === "CLOSED" ?
                        <Button type="text" style={{ backgroundColor: getStatusColor(record.status), color: 'white' }}>
                            {getStackStatusLabel(record.status)}
                        </Button> :
                            <Button className={"ant-tag-orange"} type="default">
                                Waiting for Supervisor
                            </Button>
                        ),
                    }
                )
                break;
            case "SUMMARY":
                break;
            case "ANSWER":
                break;
            default:

                break;
        }
    }

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={title}
            extra={showNewStackRequestModal ?
                <Button type="primary" onClick={showNewStackRequestModal}><PlusOutlined/>{showNewStackRequestTitle}
                </Button> : ""}
        >
            <div className="table-responsive">
                <Table
                    columns={columns}
                    dataSource={assignedStacks}
                    pagination={true}
                    className="ant-border-space"
                    onRow={(record, rowIndex) => {
                        return {
              onClick: (event) => {
                navigateToStackDetailsView(record);
                            }, // click row
              onDoubleClick: (event) => {}, // double click row
              onContextMenu: (event) => {}, // right button click row
              onMouseEnter: (event) => {}, // mouse enter row
              onMouseLeave: (event) => {}, // mouse leave row
                        };
                    }}
                />
            </div>
            <ReassignStackDialog showModal={openReassignStackDialog} onHideModal={hideModal} stackId={currentStackId}
                                 fetchData={fetchData}/>
        </Card>
    );
}

function AllStacksTable({
                            stacks,
                            navigateToStackDetailsView,
                            title
                        }) {
    
    const columns = [];
    columns.push(
        {
            title: "Stack ID",
            dataIndex: "id",
            key: "id",
            sorter: (a, b) => a.id > b.id ? 1 : -1,
            render: (id, record) => {
                return (
          <a
            className="hover-link"
            onClick={() => navigateToStackDetailsView(record)}
          >
                        {record.id}
                    </a>
                );
            }
        },
        {
            title: "Referenced Stack",
            dataIndex: ["linkedStack", "id"],
            key: "linkedStackId",
            render: (linkedStackId, record) => {
        return linkedStackId ? (
          <a
            className="hover-link"
            onClick={() => navigateToStackDetailsView(record?.linkedStack)}
          >
                        {linkedStackId}
          </a>
        ) : (
          <span>-</span>
                );
            }
        },
        {
            title: "Worker Name",
            dataIndex: "assigneeName",
            sorter: (a, b) => a.assigneeName?.localeCompare(b.assigneeName),
            key: "assigneeName",
      render: (name, record) => (
        <span
          className="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {name}
        </span>
      ),
        },
        {
            title: "StackType",
            dataIndex: "assignedStackType",
            filters: stackTypeFilterDropdown,
            onFilter: (value, record) => record.assignedStackType.includes(value),
            sorter: (a, b) => a.assignedStackType?.localeCompare(b.assignedStackType),
            key: "assignedStackType",
            render: (assignedStackType) => (
                <Button type="text" style={{ backgroundColor: getStackTypeColor(assignedStackType), color: 'white' }}>
                    {getStackTypeLabel(assignedStackType)}
                </Button>
            ),
            
        },
        {
            title: "Assigned Amount",
            dataIndex: "assignedAmount",
            key: "assignedAmount",
      sorter: (a, b) => (a.assignedAmount > b.assignedAmount ? 1 : -1),
      render: (assignedAmount, record) => (
        <span
          class="hover-link"
          onClick={() => navigateToStackDetailsView(record)}
        >
          {assignedAmount}
        </span>
      ),
        },
        {
            title: "Assigned Languages",
            dataIndex: "assignedLanguages",
            key: "assignedLanguages",
            sorter: (a, b) => a.assignedLanguages[0]?.localeCompare(b.assignedLanguages[0]),
            render: (assignedLanguages) => {
                if (!assignedLanguages || !Array.isArray(assignedLanguages)) {
                    return <span>-</span>;
                }

                const nonNullLanguages = assignedLanguages.filter(lang => lang != null);

                if (nonNullLanguages.length === 0) {
                    return <span>-</span>;
                }

        return (
          <span className="hover-link">
            {nonNullLanguages.map((lng) => getLanguagesLabel(lng)).join("/")}
          </span>
        );
            },
        },
        {
            title: "Last Update",
            dataIndex: "modified",
            key: "modified",
            defaultSortOrder: "descend",
            sorter: (a, b) => a.modified?.localeCompare(b.modified),
            render: (date) => (date ? moment(date).format("DD-MM-YYYY / hh:mm A") : "N/A"),
        },
        {
            title: "Status",
            dataIndex: "status",
            key: "status",
            filters: stackStatusFilterDropdown,
            defaultFilteredValue : ['CLOSED'],
            onFilter: (value, record) => record.status.includes(value),
            sorter: (a, b) => a.status?.localeCompare(b.status),
            render: (status) => (
                <Button type="text" style={{ backgroundColor: getStatusColor(status), color: 'white' }}>
                    {getStackStatusLabel(status)}
                </Button>
            ),
        },
    );
    

    return (
        <Card
            bordered={false}
            className="criclebox tablespace mb-24"
            title={title}
        >
            <div className="table-responsive">
                <Table
                    columns={columns}
                    dataSource={stacks}
                    pagination={true}
                    className="ant-border-space"
                    onRow={(record, rowIndex) => {
                        return {
              onClick: (event) => {
                navigateToStackDetailsView(record);
                            }, // click row
              onDoubleClick: (event) => {}, // double click row
              onContextMenu: (event) => {}, // right button click row
              onMouseEnter: (event) => {}, // mouse enter row
              onMouseLeave: (event) => {}, // mouse leave row
                        };
                    }}
                />
            </div>
        </Card>
    );
}

// Export the new components
export {StackRequestsTable, AssignedStacksTable, DeliveredStacksTable, AllStacksTable};